import React, { useState, useCallback } from "react";
import { styled, css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Row, Alert } from "components/bootstrap";
import Store from "logic/local-storage/Store";
import usePermissions from "hooks/usePermissions";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
const HIDE_DW_SEARCH_EXPLANATION_KEY = "hide-data-lake-search-explanation";
const Container = styled(Alert)(
  ({ theme }) => css`
    margin-top: 0;
    margin-bottom: ${theme.spacings.xs};
  `
);
const SearchFeatureExplanation = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const [hideExplanation, setHideExplanation] = useState(Store.get(HIDE_DW_SEARCH_EXPLANATION_KEY) === "true");
  const { isPermitted } = usePermissions();
  const hideFeatureExplanation = useCallback(() => {
    Store.set(HIDE_DW_SEARCH_EXPLANATION_KEY, "true");
    setHideExplanation(true);
  }, []);
  if (hideExplanation) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Container, { onDismiss: hideFeatureExplanation }, t("feature.text"), " ", !isPermitted("data_lake_archive:restore") && `${t("feature.contact_admin")} `, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "feature.find_more",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.DATA_LAKE_PREVIEW, text: t("feature.documentation") })
      }
    }
  )));
};
export default SearchFeatureExplanation;
